"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var framer_motion_1 = require("framer-motion");
var styles_2 = require("../styles");
var typography_1 = require("../typography/typography");
var tag_styles_1 = require("./tag_styles");
var merge_1 = __importDefault(require("lodash/merge"));
var useStyles = styles_1.makeStyles(tag_styles_1.styles);
var Tag = function (_a) {
    var _b = _a.component, Component = _b === void 0 ? framer_motion_1.motion.div : _b, containerRef = _a.containerRef, className = _a.className, _c = _a.color, color = _c === void 0 ? 'default' : _c, children = _a.children, typographyProps = _a.typographyProps, receivedStyle = _a.style, _d = _a.customClasses, oldCustomClasses = _d === void 0 ? {} : _d, _e = _a.classes, receivedClasses = _e === void 0 ? {} : _e, other = __rest(_a, ["component", "containerRef", "className", "color", "children", "typographyProps", "style", "customClasses", "classes"]);
    var theme = styles_1.useTheme();
    var mergedClasses = react_1.useMemo(function () { return merge_1.default({}, oldCustomClasses, receivedClasses); }, [
        JSON.stringify(oldCustomClasses),
        JSON.stringify(receivedClasses),
    ]);
    var classes = useStyles({ classes: mergedClasses });
    var hexColor = react_1.useMemo(function () { return styles_2.getHexFromTheme(theme, color); }, [theme, color]);
    var animationProps = {
        scale: 1,
        boxShadow: "0 " + (color ? 5 : 10) + "px " + (color ? 15 : 20) + "px 0 " + styles_2.getComponentColor(Boolean(hexColor), hexColor, false, '#d6d6d6'),
    };
    var styleProps = __assign({ color: styles_2.getComponentColor(true, hexColor) }, receivedStyle);
    var withColor = color && color !== 'default';
    return (react_1.default.createElement(Component, __assign({ ref: containerRef, className: classnames_1.default(className, classes.container), initial: { scale: 0.8 }, animate: animationProps, style: styleProps }, other),
        react_1.default.createElement(typography_1.Typography, __assign({ className: classes.typography }, (withColor && {
            color: 'light',
        }), typographyProps, { variant: "tag" }), children)));
};
exports.Tag = Tag;
